export { default } from './MobileSlider';
